export default __webpack_public_path__ + "static/media/warning.ce427460.svg";